module.exports = __webpack_public_path__ + "static/media/icon-infinity.626f3125.svg";